import { reactive } from "vue";

/**
 * Modo TV do painel (tela cheia + sem header/menu lateral).
 * Consumido por App.vue e PainelSetor2.vue.
 */
export const painelTvChrome = reactive({
  ativo: false,
});
